import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '@spartacus/asm/root';
import {
  AuthService,
  AuthStorageService,
  AuthToken,
  ClientTokenService,
  OAuthLibWrapperService,
  RoutingService,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { TokenIdleService } from '../idle-session/token-idle.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class ShimanoUserErrorHandlingService {
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  constructor(
    protected clientToken: ClientTokenService,
    protected routingService: RoutingService,
    protected authService: AuthService,
    protected authStorage: AuthStorageService,
    protected oAuthLibWrapper: OAuthLibWrapperService,
    private tokenIdleService: TokenIdleService,
    private storageService: StorageService
  ) {}

  public handleExpiredUserToken(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<AuthToken>> {
    return this.handleExpiredToken().pipe(
      switchMap((token: AuthToken) => {
        return next.handle(this.createNewRequestWithNewToken(request, token));
      })
    );
  }

  public handleExpiredRefreshToken(): void {
    // Logout user
    this.authService.coreLogout();
  }

  protected handleExpiredToken(): Observable<AuthToken> {
    let oldToken: AuthToken;
    return this.authStorage.getToken().pipe(
      tap((token: AuthToken) => {
        if (token.access_token && token.refresh_token && !oldToken) {
          let tokenExpired = +token.expires_at - 300000 < new Date().getTime();
          if (!this.asmEnabled && tokenExpired) {
            this.authService.coreLogout().finally(() => {
              this.routingService.go({ cxRoute: 'login' });
              window.location.reload();
            });
          } else {
            this.oAuthLibWrapper.refreshToken();
          }
        } else if (!token.access_token && !token.refresh_token) {
          if (!oldToken) window.location.reload();
          this.handleExpiredRefreshToken();
          // this.routingService.go({ cxRoute: 'login' });
        } else if (!token.refresh_token) {
          this.authService.coreLogout().finally(() => {
            this.routingService.go({ cxRoute: 'login' });
            window.location.reload();
          });
        }
        oldToken = oldToken || token;
      }),
      filter((token: AuthToken) => oldToken.access_token !== token.access_token),
      map((token) => (token && token.access_token ? token : undefined)),
      take(1)
    );
  }

  protected createNewRequestWithNewToken(request: HttpRequest<any>, token: AuthToken): HttpRequest<any> {
    request = request.clone({
      setHeaders: {
        Authorization: `${token?.token_type || 'Bearer'} ${token?.access_token}`,
      },
    });
    return request;
  }
}
